<div class="mr-4 mb-3">
  <div class="mb-2 font-size-small d-flex justify-content-between selector-header">{{ 'DATA_STUDIO.DATA_ANALYSIS.' + labels.title | translate }}
    @if (withExpand) {
      <ng-container *ngTemplateOutlet="expand"></ng-container>
    }
    @if (withToggle) {
      <ng-container *ngTemplateOutlet="toggle"></ng-container>
    }
  </div>
  <div class="mb-2 position-relative">
    <lib-search
      [ngClass]="{'search-filter': !!filterOptions }"
      [placeholder]="'DATA_STUDIO.DATA_ANALYSIS.' + labels.placeholder"
      [value]="searchItemValue"
      [disabled]="loadingData"
      (inputChanged)="searchItem($event)">
    </lib-search>
    @if (filterOptions) {
      <ng-container *ngTemplateOutlet="filter"></ng-container>
    }
  </div>
  <div class="p-2 selection-container">
    @if (labels.loading && (withTimer ? !items?.length : loadingData)) {
      <div
        class="h-100 d-flex justify-content-center align-items-center font-size-small">
        {{ 'DATA_STUDIO.DATA_ANALYSIS.' + labels.loading | translate }}
        @if (withTimer) {
          <app-timer></app-timer>
        }
        @if (!withTimer) {
          <app-spinner></app-spinner>
        }
      </div>
    }
    @if (!withTimer && !items?.length) {
      <div class="h-100 d-flex justify-content-center align-items-center font-size-small">
        {{ 'DATA_STUDIO.DATA_ANALYSIS.NO_SELECTION' | translate }}
      </div>
    }
    @if (items?.length && filteredItems?.length === 0 && !loadingData) {
      <div
        class="h-100 d-flex justify-content-center align-items-center font-size-small">
        {{ 'DATA_STUDIO.DATA_ANALYSIS.' + labels.noMatches | translate }}
      </div>
    }
    @if (items?.length && filteredItems?.length !== 0) {
      <div class="select-all-container p-2 d-flex justify-content-between align-items-center">
        <span class="font-weight-bold text-primary font-size-small">
          {{ 'DATA_STUDIO.DATA_ANALYSIS.' + labels.all | translate }} ({{ filteredItems?.length }})
        </span>
        <span class="mr-1 custom-checkbox">
          <input type="checkbox"
            data-testid="new-series-select-all-assets-checkbox"
            (change)="toggleAllItemsSelection()"
            [checked]="allItemsSelected" />
          <!-- <mat-checkbox
          (change)="toggleAllItemsSelection()"
          [disabled]="disabled"
          [checked]="allItemsSelected"
          [color]="'primary'">
        </mat-checkbox> -->
      </span>
    </div>
  }

  @if (items?.length && filteredItems?.length !== 0) {
    <div>
      <div class="block-container items-list mt-2" [ngClass]="{'block-container-expanded': expanded}">
        @for (block of filteredItemBlocks; track $index) {
          <div>
            <div class="block">
              @for (item of block; track $index) {
                <div class="column-item p-2 d-flex justify-content-between align-items-center" [ngClass]="{'assets-block-expanded': expanded}"
                  >
                  <span class="text-primary font-size-small">
                    {{ item.name | noUnderscore }}
                  </span>
                  <span class="mr-1 custom-checkbox">
                    <input type="checkbox"
                      data-testid="new-series-select-asset-checkbox"
                      (change)="toggleItemSelection(item)"
                      [checked]="item.selected" />
                    <!-- <mat-checkbox
                    (change)="toggleItemSelection($event, item)"
                    [checked]="item.selected"
                    [color]="'primary'">
                  </mat-checkbox> -->
                </span>
              </div>
            }
          </div>
        </div>
      }
    </div>
  </div>
}
</div>
</div>


<ng-template #expand>
  <lib-button
    id="data-analysis-expand"
    [label]="'DATA_STUDIO.DATA_ANALYSIS.' + (expanded ? 'MINIMIZE' : 'EXPAND') | translate"
    [disabled]="loadingData"
    [height]="17"
    [fontSize]="18"
    [align]="'right'"
    [color]="'primary-link'"
    (click)="toggleExpand()">
  </lib-button>
</ng-template>

<ng-template #toggle>
  <div class="d-flex">
    {{ 'DATA_STUDIO.DATA_ANALYSIS.SHARED' | translate }}
    <mat-slide-toggle
      class="ml-1 confirm-toggle"
      [disabled]="loadingData"
      (change)="pinToggle()">
    </mat-slide-toggle>
  </div>
</ng-template>

<ng-template #filter>
  @if (filterOptions) {
    <div class="filter-icon position-absolute">
      <lib-select
        id="data-studio-add-series-filter"
        [options]="filterOptions"
        [classes]="'text-primary font-size-normal cursor-pointer'"
        [checkboxesMenu]="true"
        [withIcon]="true"
        [arrowColor]="'text-tertiary'"
        [placement]="'bottom left'"
        [autoClose]="'outside'"
        [showCaret]="false"
        [doNotTranslate]="false"
        [itemClasses]="'font-size-normal-small text-left'"
        [inactiveOptionClasses]="''"
        [container]="''"
        (selectedChanged)="updateFilter()"
        (selectAllItems)="updateFilter()">
        <ng-container icon>
          <i class="far fa-filter"></i>
        </ng-container>
      </lib-select>
    </div>
  }
</ng-template>